// LandingPage.tsx
import React from "react";
import { Typography, Button, Box, Container } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Footer from "ui/Footer";
import HeroSection from "ui/Home/HeroSection";
import { BodyWithClass, Btn } from "@client/ui";
import Services from "ui/Home/services/Services";
import DriverHeroSection from "ui/Home/DriverHeroSection";
import RestaurantHeroSection from "ui/Home/RestaurantHeroSection";
import GroceryHeroSection from "ui/Home/GroceryHeroSection";
import BusinessHeroSection from "ui/Home/BusinessHeroSection";

const LandingPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div
      className="bg-background"
      style={
        {
          //backgroundColor: COLORS.backgroundPrimary,
        }
      }
    >
      <Box
        sx={{
          position: "relative",
          height: "50vh",

          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#fff",
          width: "100%",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
          }}
        />
        <div style={{ position: "relative", zIndex: 1, textAlign: "center" }}>
          {/* <HeroSection /> */}
          <div className=" font-primary h-[72px] left-[31px] top-[107px]  font-bold text-[30px] leading-[36px] text-center text-black">
            Ride smarter, arrive faster
          </div>
          <div className="font-primary text-gray-light text-center text-[18px] leading-[24px] mt-4">
            Experience the future of ride-hailing.{" "}
          </div>
          <div>
            <Btn
              style={{
                backgroundColor: "#3F0997",
                color: "#fff",
                padding: "10px 20px",
                borderRadius: "10px",
              }}
              text="Download the app"
              onClick={() => console.log("Download the app")}
            />
          </div>
        </div>
      </Box>

      <div className="flex justify-center mt-10 border-t border-b border-gray-light">
        <img
          src="/image/tapzus-home.png"
          alt="home"
          width={500}
          style={{
            maxWidth: "100%",
          }}
        />
      </div>
      <div>
        <div>
          <BodyWithClass
            text={"Our services "}
            className={"font-primary font-[700] text-[40px] text-center mt-10"}
          />
        </div>
        <Services />
      </div>
      <div className="mt-[150px]">
        <div>
          <DriverHeroSection />
        </div>
        <div>
          <RestaurantHeroSection />
        </div>
        <div>
          <GroceryHeroSection />
        </div>
        <div>
          <BusinessHeroSection />
        </div>
      </div>

      <Box sx={{}}>
        <Footer />
      </Box>
    </div>
  );
};

export default LandingPage;
